import React from 'react';
import { workshopData } from '../data/mock';
import { Button } from '../components/ui/button';
import {
  CheckCircle,
  MessageCircle,
  CheckCheck
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
  const navigate = useNavigate();

  const handleWhatsAppJoin = () => {
    window.open(workshopData.thankYou.whatsappLink, '_blank');
  };

  return (
    <div className="thankyou-premium" data-testid="thankyou-page">

      {/* Decorative sparkles */}
      <div className="sparkle-dot sparkle-dot-1" />
      <div className="sparkle-dot sparkle-dot-2" />
      <div className="sparkle-dot sparkle-dot-3" />
      <div className="sparkle-dot sparkle-dot-4" />
      <div className="sparkle-dot sparkle-dot-5" />

      <div className="thankyou-container thankyou-minimal">

        {/* Payment confirmed badge */}
        <div className="payment-badge" data-testid="payment-badge">
          <CheckCheck size={13} />
          Payment Confirmed
        </div>

        {/* Success icon */}
        <CheckCircle size={80} className="success-icon" data-testid="success-icon" />

        {/* Headline */}
        <h1 className="thankyou-headline" data-testid="thankyou-headline">
          {workshopData.thankYou.headline}
        </h1>

        <p className="thankyou-message" data-testid="thankyou-message">
          {workshopData.thankYou.message}
        </p>

        {/* WhatsApp CTA — Large Gold Button */}
        <Button
          className="whatsapp-btn-gold-large gold-cta-animated"
          onClick={handleWhatsAppJoin}
          data-testid="whatsapp-join-button"
        >
          <MessageCircle size={22} />
          Join WhatsApp Community
        </Button>

        <button
          className="back-link"
          onClick={() => navigate('/')}
          data-testid="back-to-home-button"
        >
          ← Back to Home
        </button>
      </div>
    </div>
  );
};

export default ThankYouPage;
